import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { checkConsentStatus } from '../actions';
import { postMessageSuccess } from '../helpers/postMessage';
import ThemedSpinner from './ThemedSpinner';
//import ConsentError from './ConsentError';

const ConsentTransfer = (props) => {
  const dispatch = useDispatch();
  const { institution, consent_guid, redirect_url, theme } = props;
  const [showUI, setShowUI] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [shouldPoll, setShouldPoll] = useState(false);

  // Only start polling when redirection is successful or user clicks
  useEffect(() => {
    if (!shouldPoll) return;

    let intervalId;
    if (!institution) {
      return;
    }

    const pollConsentStatus = async () => {
      try {
        await dispatch(checkConsentStatus(consent_guid, institution));
      } catch (err) {
      }
    };
    intervalId = setInterval(pollConsentStatus, 7000);
    
    return () => clearInterval(intervalId);
     
  }, [shouldPoll, dispatch, consent_guid, institution]);

    /*const intervalId = setInterval(pollConsentStatus, 7000);
    return () => clearInterval(intervalId);
  }, [dispatch, consent_guid, institution]);*/

  useEffect(() => {
    const redirectUrl = redirect_url;
    if (!redirectUrl) return;
        // Try auto-redirect after 3 seconds (like original PHP)

    const autoRedirectTimer = setTimeout(() => {
    
      if (!clicked) {
  
        const win = window.open(redirectUrl, "_blank");
        
        // If popup was successful, dispatch message and start polling
        if (win && !win.closed && typeof win.closed !== 'undefined') {
          const slug = institution.slug || institution.name || consent_guid;
          dispatch(postMessageSuccess("awaiting_consent", {slug: slug, type: "auto_refresh"}));
          setShouldPoll(true); // Start polling after successful redirect
        } else {
          // Popup blocked, show the manual button
          setShowUI(true);
        }
      }
    }, 3000);


    return () => {
      clearTimeout(autoRedirectTimer);
    };
  }, [redirect_url, dispatch, consent_guid, institution, clicked]);

  const handleClick = (e) => {
    e.preventDefault();
    
    const slug = institution.slug || institution.name || consent_guid;
    dispatch(postMessageSuccess("awaiting_consent", {slug: slug, type: "clicked"}));
    
    window.open(redirect_url, "_blank");
    setClicked(true);
    setShowUI(false);
    setShouldPoll(true); // Start polling after manual click
  };

  return (
    <div id="intro">
      <div id="" className="consent-data-wrapper transfer-to-provider">
        <h2 className="form-group text-center">
          Transferring you to <strong>{institution.name}</strong>
        </h2>
        <ThemedSpinner theme={theme} />
        <div className="form-group text-center">We are redirecting you to the {institution.name} where you will login securely before viewing and authorising this request.</div>
        {showUI && !clicked && (
          <>
            <span id="redirectMsg" style={{  background: "yellow", padding: "5px", border: "0px" }}>
              If you are not redirected to the bank page, please{" "}
            </span>
            <a 
              id="openBtn" 
              href={redirect_url}
              target="_blank" 
              rel="noopener noreferrer" 
              onClick={handleClick}
              style={{  background: "red", boxShadow: "none", border: "none", padding: "5px", color: "#fff", fontWeight: "bold", margin: "1px 0 0", cursor: "pointer" }}
            >
              click here
            </a>
          </>
        )}        
      </div>
    </div>
  );
};

export default ConsentTransfer;